import { AssistantNodeAction, NodeType } from "../NodeType";

export {
  defaultAssistantNode,
  defaultVoiceAssistantNode,
  defaultWhatsappAssistantNode,
  VoiceAssistantNodeResult,
  voiceAssistantNodeResultConfig,
  TAssistantNode,
  TAssistantNodeConfig,
  IVoiceAssistantNodeConfig,
  IWhatsappAssistantNodeConfig,
  TVoiceAssistantNodeResult,
};

const VoiceAssistantNodeResult = {
  DEFAULT: "default",
  UNANSWERED: "unanswered",
  BUSY: "busy",
  FAILED: "failed",
  CANCELLED: "canceled",
  CRITERIA_NOT_MET: "criteria_not_met"
} as const;

const voiceAssistantNodeResultConfig = {
  [VoiceAssistantNodeResult.BUSY]: {
    label: "Busy",
    color: "amber",
    outputPort: VoiceAssistantNodeResult.BUSY,
  },
  [VoiceAssistantNodeResult.UNANSWERED]: {
    label: "Unanswered",
    color: "pink",
    outputPort: VoiceAssistantNodeResult.UNANSWERED,
  },
  [VoiceAssistantNodeResult.FAILED]: {
    label: "Failed",
    color: "red",
    outputPort: VoiceAssistantNodeResult.FAILED,
  },
  [VoiceAssistantNodeResult.DEFAULT]: {
    label: "default",
    color: "green",
    outputPort: VoiceAssistantNodeResult.DEFAULT,
  },
  [VoiceAssistantNodeResult.CANCELLED]: {
    label: "Cancelled",
    color: "blue",
    outputPort: VoiceAssistantNodeResult.CANCELLED,
  },
  [VoiceAssistantNodeResult.CRITERIA_NOT_MET]: {
    label: "Criteria Fail",
    color: "red",
    outputPort: VoiceAssistantNodeResult.CRITERIA_NOT_MET
  }
} as const;

type TVoiceAssistantNodeResult =
  (typeof VoiceAssistantNodeResult)[keyof typeof VoiceAssistantNodeResult];

const defaultVoiceAssistantNode = {
  name: "Voice Call",
  description: "",
  assistantId: "",
  action: AssistantNodeAction.VOICE_CALL,
  inputMapping: {
    phoneNumberField: "",
  },
  fromIdentifier: "",
  noAnswerRechurn: {
    enabled: false,
    attemptsPerDay: 5,
    totalDays: 3,
    retryIntervalMinutes: 60,
    stoppingCriteria: {
      fieldName: "",
      fieldValue: ""
    }
  },
};

const defaultWhatsappAssistantNode = {
  name: "Whatsapp Message",
  description: "",
  assistantId: "",
  action: AssistantNodeAction.WHATSAPP_MESSAGE,
  inputMapping: {
    phoneNumberField: "",
    attributesField: {},
  },
  fromIdentifier: "",
  templateLanguage: "",
  templateName: "",
};

const defaultAssistantNode = {
  [AssistantNodeAction.VOICE_CALL]: defaultVoiceAssistantNode,
  [AssistantNodeAction.WHATSAPP_MESSAGE]: defaultWhatsappAssistantNode,
};

type TAssistantNode = {
  nodeId: string;
  type: typeof NodeType.ASSISTANT;
  name: string;
  description?: string;
  config: TAssistantNodeConfig;
};

type TAssistantNodeConfig =
  | IVoiceAssistantNodeConfig
  | IWhatsappAssistantNodeConfig;

interface IVoiceAssistantNodeConfig {
  name: string;
  description?: string;
  assistantId: string;
  action: typeof AssistantNodeAction.VOICE_CALL;
  inputMapping: {
    phoneNumberField: string;
  };
  fromIdentifier: string;
  noAnswerRechurn: INoAnswerRechurn;
}

interface INoAnswerRechurn {
  enabled: boolean;
  attemptsPerDay: number;
  totalDays: number;
  retryIntervalInMinutes: number;
  stoppingCriteria: {
    fieldName: string;
    fieldValue: string;
  }
}

interface IWhatsappAssistantNodeConfig {
  name: string;
  description?: string;
  assistantId: string;
  action: typeof AssistantNodeAction.WHATSAPP_MESSAGE;
  inputMapping: {
    phoneNumberField: string;
  };
  fromIdentifier: string;
  templateName: string;
  templateLanguage: string;
  templateParameters: any[];
}
